import announcement from '@/api/payment-announcement'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  main_programs: [],
  sub_programs: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_MAIN_PROGRAMS(state, data) {
    state.main_programs = data
  },
  SET_SUB_PROGRAMS(state, data) {
    state.sub_programs = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return announcement.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return announcement.store(data)
  },

  update(context, data) {
    return announcement.update(data)
  },
  destroy(context, id) {
    return announcement.destroy(id)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await announcement.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  async getSubProgram(context, acp_id) {
    context.state.sub_programs = []
    context.state.ac_terms = []
    let response = await announcement.getSubProgram(acp_id)
    context.commit('SET_SUB_PROGRAMS', response)
    return response
  },

  async dataBeforeCreate(context) {
    if (!context.state.main_programs.length > 0) {
      let response = await announcement.getMainProgram()
      context.commit('SET_MAIN_PROGRAMS', response)
    }
  }
}
